import { FAVORITE_TAG_NAME } from "../constants.ts";
import { useBoard } from "./useBoard.ts";

export const useFavoriteTagUuid = () => {
  const { board } = useBoard();
  return board.tags.find((tag) => tag.name === FAVORITE_TAG_NAME)?.uuid;
};
